﻿cb.define([], function () {
  var ST_st_storetransferlist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
    	var self = this;
    	viewmodel.on("beforeBatchdelete",function(args){
    		var rowIndex = args.params.params.index;
        return self.beforeDelete(viewmodel, rowIndex);
      });
      viewmodel.on("beforeEdit",function(args){
    		var rowIndex = args.params.params.index;
        return self.beforeEdit(viewmodel, rowIndex);
      });
      //联查其他出库单
			viewmodel.on('queryothout', function(args) {
				var selectRow = viewmodel.getGridModel().getData()[args.params.index];
				var originid = selectRow.id;
				var proxy = cb.rest.DynamicProxy.create({ ensure: { url: args.cSvcUrl, method: args.cHttpMethod } });
				var params = {
					action: 'queryothout',
					billnum: 'st_storetransfer',
					data: JSON.stringify(originid)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					if(result != undefined) {
						cb.utils.alert('操作成功', 'success');
						viewmodel.execute('refresh');
						var params = {
							mode: 'edit',
							readOnly: true,
							id: JSON.parse(result).id
						};
						var data = {
							billtype: 'voucher',
							billno: JSON.parse(result).billno,
							params: params
						};
						cb.loader.runCommandLine('bill', data, viewmodel);
					}

				});
			});
			//联查其他入库单
			viewmodel.on('queryothin', function(args) {
				var selectRow = viewmodel.getGridModel().getData()[args.params.index];
				var originid = selectRow.id;
				var proxy = cb.rest.DynamicProxy.create({ ensure: { url: args.cSvcUrl, method: args.cHttpMethod } });
				var params = {
					action: 'queryothin',
					billnum: 'st_storetransfer',
					data: JSON.stringify(originid)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					if(result != undefined) {
						cb.utils.alert('操作成功', 'success');
						viewmodel.execute('refresh');
						var params = {
							mode: 'edit',
							readOnly: true,
							id: JSON.parse(result).id
						};
						var data = {
							billtype: 'voucher',
							billno: JSON.parse(result).billno,
							params: params
						};
						cb.loader.runCommandLine('bill', data, viewmodel);
					}

				});
			});
    },
    beforeDelete: function(viewmodel, rowIndex){
      	var currentRow = viewmodel.getGridModel().getRow(rowIndex);
      	if(currentRow.status === 1){
        	cb.utils.alert("已审核的单据不允许删除！");
        	return false;
      	}
    },
    beforeEdit: function(viewmodel, rowIndex){
      var currentRow = viewmodel.getGridModel().getRow(rowIndex);
      	if(currentRow.status === 1){
        	cb.utils.alert("已审核的单据不允许编辑！");
        	return false;
      	}
    },
  }
  try {
    module.exports = ST_st_storetransferlist_VM_Extend;
  } catch (error) {

  }
  return ST_st_storetransferlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storetransferlist_VM.Extend.js